'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */
var secondsToMilliseconds = function (seconds) {
  return seconds * 1000;
};

exports.secondsToMilliseconds = secondsToMilliseconds;
